import React from 'react';

// Small reusable "Variant C — Compact Pill" style bubble used to render
// Withdraw Done / Deposit Done / Coin Cut action-sticker messages in chat.
const STICKER_META = {
  withdraw_done: { label: 'Withdraw Done', color: '#10b981', emoji: '💸' },
  deposit_done:  { label: 'Deposit Done',  color: '#3b82f6', emoji: '💰' },
  coin_cut:      { label: 'Coin Cut',      color: '#f59e0b', emoji: '✂️' },
};

const ActionStickerBubble = ({ sticker }) => {
  if (!sticker || !sticker.type) return null;
  const meta = STICKER_META[sticker.type] || { label: sticker.type, color: '#6b7280', emoji: '⭐' };
  return (
    <div
      data-testid={`action-sticker-bubble-${sticker.type}`}
      className="inline-flex flex-col items-center text-white select-none"
      style={{
        background: meta.color,
        borderRadius: '999px 999px 14px 14px',
        padding: '10px 18px 12px',
        minWidth: 120,
        boxShadow: '0 3px 8px rgba(0,0,0,0.18)',
      }}
    >
      <span style={{ fontSize: 20, lineHeight: 1 }}>{meta.emoji}</span>
      <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.4, textTransform: 'uppercase', opacity: 0.95, marginTop: 3 }}>
        {meta.label}
      </span>
      {sticker.amount ? (
        <span
          style={{
            fontSize: 14,
            fontWeight: 800,
            background: 'rgba(0,0,0,0.18)',
            padding: '2px 10px',
            borderRadius: 8,
            marginTop: 4,
          }}
        >
          ₹ {sticker.amount}
        </span>
      ) : null}
    </div>
  );
};

export default ActionStickerBubble;
